// extracted by mini-css-extract-plugin
export default {"container":"close_container__frKWS","main":"close_main__zSA8u","box":"close_box__EUe66","title":"close_title__tZGPD","video":"close_video__FxWI7"};